import { render, staticRenderFns } from "./BasicLayout.vue?vue&type=template&id=566b2a59&scoped=true"
import script from "./BasicLayout.vue?vue&type=script&lang=js"
export * from "./BasicLayout.vue?vue&type=script&lang=js"
import style0 from "./BasicLayout.vue?vue&type=style&index=0&id=566b2a59&prod&lang=less"
import style1 from "./BasicLayout.vue?vue&type=style&index=1&id=566b2a59&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566b2a59",
  null
  
)

export default component.exports